import { useMutation } from 'react-query'
import { useAppointmentsService } from '../services/appointments'
import { AppointmentCreateRequest, Appointment } from '../../types'

const useCreateAppointment = () => {
  const { createAppointment } = useAppointmentsService()

  return useMutation<Appointment, Error, AppointmentCreateRequest>(createAppointment)
}

export { useCreateAppointment }
